import { useCallback, useMemo } from 'react';
import { ScreenName } from 'common/utils/pp_tracking';
import InfinityScroll from 'components/v2/molecules/infinity-scroll';
import PostList from 'components/v2/organisms/post-list';
import { useInfiniteQuery } from 'react-query';
import {
  getTopicRelatedPosts,
  TopicRelatedPostsResult,
  TopicRelatedPostsTypeEnum,
} from 'service/post_topic';
import { PostItemType } from 'service/timeline';
import useGlobalStore from 'store/global';

const TopicPostsSection = ({
  topicName,
  type,
}: {
  topicName: string;
  type: TopicRelatedPostsTypeEnum;
}) => {
  const isAuthInit = useGlobalStore((state) => state.isAuthInit);
  const getNextPageParam = useCallback(
    (lastPage: TopicRelatedPostsResult, pages: TopicRelatedPostsResult[]) => {
      const posts = lastPage?.data?.posts;
      if (posts && posts.length > 0) {
        return pages.length + 1;
      }
    },
    [],
  );
  const { data, fetchNextPage, isFetchingNextPage, isFetched, hasNextPage } =
    useInfiniteQuery(
      ['topic-posts', topicName, type],
      async ({ pageParam = 1 }) => {
        if (!isAuthInit) return Promise.reject();
        // Using timeline API for now - can be replaced with topic-specific API
        return getTopicRelatedPosts({
          topic: topicName,
          page: pageParam as number,
          type: type,
        });
      },
      {
        getNextPageParam: getNextPageParam,
        enabled: isAuthInit,
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 15 * 60 * 1000,
        cacheTime: 15 * 60 * 1000,
      },
    );

  const pages = data?.pages;
  const posts: PostItemType[] = useMemo(
    () =>
      pages
        ? pages.reduce<PostItemType[]>((curr, page) => {
            const posts = page?.data?.posts || [];
            return curr.concat(posts);
          }, [])
        : [],
    [pages],
  );

  return (
    <InfinityScroll
      fetchNextPage={fetchNextPage}
      isLoading={isFetchingNextPage}
      hasNextPage={hasNextPage}
    >
      <PostList
        posts={posts}
        screen={ScreenName.TopicPosts}
        isFetched={isFetched}
        noPostMessage="投稿はありません"
      />
    </InfinityScroll>
  );
};

export default TopicPostsSection;
